import { Dispatch } from 'redux'
import { AuthActionType } from 'state/action-types/authTypes'
import { Action } from '../actions/authActions'
import { User } from 'interfaces/user'

export const login = (data: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: AuthActionType.LOGIN,
            payload: data
        })
    }
}

export const me = (data: User) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: AuthActionType.ME,
            payload: data
        })
    }
}